import React, { useState, useEffect } from "react";
import Link from "next/link";
import Logo from "components/Logo";
import cn from "classnames";

const Navbar = ({ is_dark, style, current_page }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  function onScroll() {
    setMenuOpen(false);
  }

  function onMenuClick() {
    setMenuOpen(!menuOpen);
  }

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  return (
    <div
      className={cn(
        "Navbar",
        is_dark && "Navbar--dark",
        current_page == "for-leaders" && "Navbar--leadership",
        current_page == "for-advisors" && "Navbar--brokers",
        current_page == "investors" && "Navbar--investors"
      )}
      style={{ ...style }}
      onScroll={onScroll}
    >
      <nav>
        <Link href="/" className="Navbar__logo no-hover -mt-1">
          <Logo is_dark={is_dark} />
        </Link>
        <button
          className="Navbar__menu-button"
          aria-label="Mobile menu button"
          onClick={onMenuClick}
        >
          <span
            className={cn(
              "Navbar__menu-icon",
              menuOpen && "Navbar__menu-icon--open"
            )}
          />
        </button>
        <div className={cn("Navbar__menu", menuOpen && "Navbar__menu--open")}>
          <ul>
            <Link
              href="/leadership"
              id="button_for-leaders"
              className={cn(
                "Navbar__link Navbar__link--text",
                current_page == "for-leaders" && "no-hover Navbar__current-page"
              )}
            >
              For Leaders
            </Link>
            {/* GTM triggers key off the button_for-brokers id; keep it until GTM is updated */}
            <Link
              href="/advisors"
              id="button_for-brokers"
              className={cn(
                "Navbar__link Navbar__link--text",
                current_page == "for-advisors" &&
                  "no-hover Navbar__current-page"
              )}
            >
              For Advisors
            </Link>
            <Link
              href="https://investors.teamshares.com/"
              id="button_investors"
              className={cn(
                "Navbar__link Navbar__link--text",
                current_page == "investors" && "no-hover Navbar__current-page"
              )}
            >
              For Investors
            </Link>
            {/* TODO: Readd resources link once we can add Investors to navbar in blog */}
            {/* <Link
              id="button_navbar-resources"
              href="https://www.teamshares.com/resources/"
              className="Navbar__link Navbar__link--text"
            >
              Resources
            </Link> */}
            {current_page == "for-leaders" && (
              <Link
                id="button_navbar-apply-now"
                href="https://jobs.lever.co/teamshares?department=Teamshares&team=President%20Network"
                className="Navbar__link ts-button ts-button--accent large"
                target="_blank"
              >
                Apply now
              </Link>
            )}
            {current_page == "for-advisors" && (
              <Link
                href="https://teamshares.surveysparrow.com/s/Teamshares-Referral-Form/tt-zTwHI"
                id="button_broker-referral-form"
                className="Navbar__link ts-button ts-button--accent large"
                target="_blank"
              >
                Refer your listing or business
              </Link>
            )}
            {current_page == undefined && (
              <Link
                href="https://os.teamshares.com/users/sign_in"
                id="button_os-login"
                className="Navbar__link ts-button ts-button--accent large"
                target="_blank"
              >
                Log in
              </Link>
            )}
          </ul>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
